/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconCheckmark} from '../icons/checkmark.svg';

import styles from '../styles/progress.module.scss'

interface ProgressProps {
    progress: number;
}

export function Progress(props: ProgressProps) {
    const {t} = useTranslation();
    return (
        <div className={styles.container}>
            <div className={styles.progressBackground}><div className={styles.progress} style={{width: `${Math.max(0, Math.min(100, 25 + props.progress * 100))}%`}}></div><div className={styles.progressGreen} style={{width: `${Math.max(0, Math.min(100, props.progress * 100))}%`}}></div></div>
            <div className={`${styles.circle} ${styles.circleFilled} ${props.progress >= 0.5 ? styles.circleChecked : ''}`}><span>1</span><IconCheckmark/><span>{t('progress.orderlist')}</span></div>
            <div className={`${styles.circle} ${props.progress >= 0.5 ? styles.circleFilled : ''} ${props.progress >= 1.0 ? styles.circleChecked : ''}` }><span>2</span><IconCheckmark/><span>{t('progress.customerdata')}</span></div>
            <div className={`${styles.circle} ${props.progress >= 1.0 ? styles.circleFilled : ''}`}><span>3</span><IconCheckmark/><span>{t('progress.overview')}</span></div>
        </div>
    );
};
